import { createContext } from 'react';

export const LocaleContext = createContext();

// Create context to control sidebar width and dashboard width when expand/collapse
export const SidebarContext = createContext({});

export const DashboardContext = createContext({});
